import { FAQPage } from '@/components/equip/FAQPage';
import { physicianFAQ, physicianFAQCategories } from '@/data/physician-faq';
import type { EmploymentStatus } from '@/data/types';

interface PhysicianFAQProps {
  employmentStatus?: EmploymentStatus;
}

export function PhysicianFAQ(_props: PhysicianFAQProps = {}): JSX.Element {
  return (
    <FAQPage
      rolePrefix="physician"
      items={physicianFAQ}
      categories={physicianFAQCategories}
    />
  );
}
